import React from 'react';

import { accountHomeBaseUrl, externalLinks } from '@consumer-frontend/nc-api';
import { externalLinkModalConfig } from '@consumer-frontend/nc-utils';
import { Icon, Image } from '@consumer-frontend/shared-ui';

import { NcLegacyLink } from '../NcLegacyLink';
import { NcModalAnchor } from '../NcModal';
import { NcSupportNumberLink } from '../NcSupportNumberLink';

import '@consumer-bootstrap/brands/netcredit/footer.scss';
import '@consumer-bootstrap/netcredit.scss';

export type NcSocialT = React.FC;

export const NcSocial: NcSocialT = () => {
  /* eslint-disable max-len */
  const fbIconURL = 'https://s3.us-east-2.amazonaws.com/enova-brand-icon-assets-prod.us-east-2/Brand+Icons/NetCredit/UI+Icons/SVG/fb_logo.svg';
  const xIconURL = 'https://s3.us-east-2.amazonaws.com/enova-brand-icon-assets-prod.us-east-2/Brand+Icons/NetCredit/UI+Icons/SVG/x-logo-white.svg';
  /* eslint-enable max-len */

  return (
    <div className="d-flex flex-column social">
      <NcLegacyLink href={accountHomeBaseUrl}>
        <Image
          src="/assets/images/NC_Inverse-standard_TV_tagline.svg"
          alt="NetCredit Footer Logo"
          style={{
            width: '12.8125rem',
          }}
        />
      </NcLegacyLink>

      <NcSupportNumberLink withIcon />

      <a href="mailto:support@netcredit.com">
        <Icon iconName="envelope-fill" />
        support@netcredit.com
      </a>

      <div className="d-flex flex-row social-links">
        <NcModalAnchor
          {...externalLinkModalConfig}
          modalOnClick={() => window.open(externalLinks.facebook, '_blank')}
        >
          <a href={externalLinks.facebook}>
            <Image
              src={fbIconURL}
              alt="NetCredit on Facebook"
            />
          </a>
        </NcModalAnchor>
        <NcModalAnchor
          {...externalLinkModalConfig}
          modalOnClick={() => window.open(externalLinks.x, '_blank')}
        >
          <a href={externalLinks.x}>
            <Image
              src={xIconURL}
              alt="NetCredit on X (formerly Twitter)"
            />
          </a>
        </NcModalAnchor>
      </div>
    </div>
  );
};
